require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ../js/~/babel-runtime/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 640
// module chunks = 0